import appService from 'services/common';

const getOnboardingTasks = (params?: object) => {
  return appService.get('/missions-manage', { params });
};

export { getOnboardingTasks };
